// Copyright (C) 2020 TANNER AG

import gql from "graphql-tag";

export const FullPodcastsFragment = gql`
    fragment FullPodcastsFragment on Podcast {
        id
        publicationDate
        keywords
        title
        shortdescription
        description
        mediaUrl
        mediaType
        media {
            id
            fileName
            url
            stage
            handle
            mimeType
        }
        teaserImage {
            handle
            fileName
            width
            height
            url
            mimeType
        }
    }
`;

export default gql`
    query Podcasts($lang: [Locale!]!, $first: Int, $skip: Int, $stage: Stage!) {
        podcasts(first: $first, skip: $skip, locales: $lang, stage: $stage, orderBy: publicationDate_DESC) {
            ...FullPodcastsFragment
        }
        totalPodcasts: podcastsConnection(locales: $lang, stage: $stage) {
            aggregate {
                count
            }
        }
    }
    ${FullPodcastsFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/podcasts.js